document.addEventListener('DOMContentLoaded', function () {
    // eslint-disable-next-line no-undef
    if (window.location.pathname.includes('/tag/regional')) {
        // eslint-disable-next-line no-undef
        const button = document.querySelector('.gh-action-get-info');
        if (button) {
            button.click(); // Trigger the click event
            // eslint-disable-next-line no-undef
            document.querySelectorAll('li.gh-action-get-info').forEach(li => li.remove());
        }
    }

    // eslint-disable-next-line no-undef
    const mobileMenu = document.querySelector('.js-mobile-menu');
    // eslint-disable-next-line no-undef
    const modal = document.querySelector('.gh-mobile-modal');
    // eslint-disable-next-line no-undef
    const closeModal = document.querySelector('.js-mobile-modal-close');

    if (mobileMenu && modal && closeModal) {
        mobileMenu.addEventListener('click', function () {
            modal.style.display = 'block';
        });

        closeModal.addEventListener('click', function () {
            modal.style.display = 'none';
        });
    }

    // eslint-disable-next-line no-undef
    const mobileSidebar = document.querySelector('.js-open-sidebar');
    // eslint-disable-next-line no-undef
    const modalSidebar = document.querySelector('.gh-mobile-sidebar-modal');
    // eslint-disable-next-line no-undef
    const closeModalSidebar = document.querySelector('.js-mobile-sidebar-modal-close');

    if (mobileSidebar && mobileSidebar && closeModalSidebar) {
        mobileSidebar.addEventListener('click', function () {
            modalSidebar.style.display = 'block';
        });

        closeModalSidebar.addEventListener('click', function () {
            modalSidebar.style.display = 'none';
        });
    }

    // eslint-disable-next-line no-undef
    document.addEventListener('click', function (event) {
        const target = event.target.closest('.js-copy-post-url');
        if (!target) {
            return;
        }

        const url = target.getAttribute('data-url');
        if (!url) {
            return;
        }

        // eslint-disable-next-line no-undef
        navigator.clipboard.writeText(url).then(() => {
            // eslint-disable-next-line no-console
            console.log('Copied:', url);
        }).catch((err) => {
            // eslint-disable-next-line no-console
            console.error('Failed to copy:', err);
        });
    });

    // eslint-disable-next-line no-undef
    const dateDividers = document.querySelectorAll('.date-divider');
    let lastDate = '';

    dateDividers.forEach((div) => {
        const currentDate = div.innerText.trim();

        if (currentDate === lastDate) {
            div.style.display = 'none';
        } else {
            lastDate = currentDate;
        }
    });

    // eslint-disable-next-line no-undef
    const postFeed = document.getElementById('ziar-post-feed');
    // eslint-disable-next-line no-undef
    const loadMoreLink = document.getElementById('ziar-load-more');
    let loading = false;

    async function loadMorePosts() {
        if (loading || !loadMoreLink) {
            return;
        }

        loading = true;

        const nextUrl = loadMoreLink.href;

        try {
            const response = await fetch(nextUrl);
            const text = await response.text();

            // eslint-disable-next-line no-undef
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, 'text/html');

            const newPosts = doc.querySelectorAll('#post-feed > *');
            const newPagination = doc.querySelector('#load-more');

            newPosts.forEach(post => postFeed.appendChild(post));

            if (newPagination) {
                loadMoreLink.href = newPagination.href;
                loading = false;
            } else {
                // No more pages
                loadMoreLink.parentElement.remove();
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Error loading more posts:', error);
        }
    }

    // eslint-disable-next-line no-undef
    // window.addEventListener('scroll', () => {
    //     // eslint-disable-next-line no-undef
    //     const {scrollTop, scrollHeight, clientHeight} = document.documentElement;
    //     loadMorePosts()
    //         .then(() => scrollTop + clientHeight >= scrollHeight - 300);
    // });

    // eslint-disable-next-line no-undef
    const goTopBtn = document.getElementById('goTopBtn');

    // eslint-disable-next-line no-undef
    window.addEventListener('scroll', function () {
        // eslint-disable-next-line no-undef
        if (window.scrollY > 300) {
            goTopBtn.style.display = 'block';
        } else {
            goTopBtn.style.display = 'none';
        }
    });

    // Smooth scroll to top on click
    goTopBtn.addEventListener('click', function () {
        // eslint-disable-next-line no-undef
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
});

